import { BrowserModule } from "@angular/platform-browser";
//import { NgModule } from '@angular/core';
//import {FormsModule} from '@angular/forms';
import { DatePipe } from "@angular/common";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import {
  NgModule,
  NO_ERRORS_SCHEMA,
  CUSTOM_ELEMENTS_SCHEMA,
} from "@angular/core";
import { CAPService } from "./core/services/cap-service";
import { AppRoutingModule } from "./app-routing.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AppComponent } from "./app.component";

import { HttpClientModule } from "@angular/common/http";
import { RebarAuthModule } from "./core/rebarauth/rebar.auth.module";
import { AppConfigService } from "./core/services/app-config.service";
import { APP_INITIALIZER } from "@angular/core";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatIconModule } from "@angular/material/icon";
import { MatMomentDateModule } from "@angular/material-moment-adapter";
import { MatNativeDateModule } from "@angular/material/core";
import { AgGridModule } from "ag-grid-angular";

import { UseraccessComponent } from "./feature/admin/useraccess.component";
import { GatewayComponent } from "./feature/config/gateway.component";
import { CallratesComponent } from "./feature/config/callrates.component";
import { CallrulesComponent } from "./feature/config/callrules.component";
import { ProjectComponent } from "./feature/config/project.component";
import { DeviceComponent } from "./feature/config/device.component";
import { TelcoComponent } from "./feature/config/telco.component";
import { DestinationComponent } from "./feature/config/destination.component";
import { CurrenconversionComponent } from "./feature/config/currenconversion.component";
import { CountryconfigurationComponent } from "./feature/config/countryconfiguration.component";
import { CommonareaphoneComponent } from "./feature/config/commonareaphone.component";
import { DailinconferenceComponent } from "./feature/config/dailinconference.component";
import { EncrDecrService } from "./core/services/EncrDecrService";

import { LeaversComponent } from "./feature/requisitationToPay/leavers.component";
import { RecoveryReportsComponent } from "./feature/reports/recovery-reports.component";
import { SummaryReportsComponent } from "./feature/reports/summary-reports.component";
import { PagerService } from "./core/services/pager.service";
import { HomeComponent } from "./feature/home/home.component";
import { DashboardComponent } from "./feature/dashboard/dashboard.component";
import { DashboardFeedbackComponent } from "./feature/dashboard/dashboard-feedback.component";
import { DashboardProjectLeadComponent } from "./feature/dashboard/dashboard-project-lead.component";
import { DashboardVoiceAdminCAPComponent } from "./feature/dashboard/dashboard-voice-admin-cap.component";
import { DashboardVoiceAdminCountryComponent } from "./feature/dashboard/dashboard-voice-admin-country.component";
import { DashboardVoiceAdminGatewayComponent } from "./feature/dashboard/dashboard-voice-admin-gateway.component";
import { DashboardVoiceAdminGlobalCountryComponent } from "./feature/dashboard/dashboard-voice-admin-global-country.component";
import { DashboardVoiceAdminTrunkCallComponent } from "./feature/dashboard/dashboard-voice-admin-trunk-call.component";
import { OnlineSupportComponent } from "./feature/home/online-support.component";
import { RetaggingOfCallsComponent } from "./feature/requisitationToPay/retagging-of-calls.component";
import { SuggestionAndFeedbackComponent } from "./feature/help/suggestion-and-feedback.component";
import { LoginComponent } from "./feature/login/login.component";
import {
  MsalService,
  MsalRedirectComponent,
  MsalModule,
} from "@azure/msal-angular";

import { SuggestionsComponent } from "./feature/admin/suggestions.component";
import { MyprofileComponent } from "./feature/profile/myprofile/myprofile.component";
import { ActivateAuthcodeComponent } from "./feature/authcodedetails/activate-authcode.component";
import { DeactivateAuthcodeComponent } from "./feature/authcodedetails/deactivate-authcode/deactivate-authcode.component";
import { NgIdleKeepaliveModule } from "@ng-idle/keepalive";
import { MomentModule } from "ngx-moment";

import { CacheInterceptor } from "./core/services/cache-interceptor.service";
import { TermsAndConditionsComponent } from "./feature/home/terms-and-conditions.component";
import { ShortCodeComponent } from "./feature/config/short-code.component";
import { MainDashboardComponent } from "./feature/dashboard/main-dashboard.component";
import { SourceComponent } from "./feature/config/source.component";
import { GroupaccessComponent } from "./feature/admin/groupaccess.component";
import { ModalComponent } from "./modal/modal.component";
import { AlertsComponent } from "./alerts/alerts.component";
import { ToastComponent } from "./toast/toast.component";
import { ManageaccessComponent } from "./feature/admin/manageaccess.component";
import { SchedulereportsComponent } from "./feature/config/schedulereports.component";
import { RecoveryreportsComponent } from "./feature/config/recoveryreports.component";
import { SummaryreportsComponent } from "./feature/config/summaryreports.component";
import { AddAuthLevelComponent } from "./feature/config/add-auth-level.component";
// import { DatadogSessionService } from './core/services/datadog-session.service';;

@NgModule({
  declarations: [
    AppComponent,
    RecoveryReportsComponent,
    SummaryReportsComponent,
    UseraccessComponent,
    GatewayComponent,
    CallratesComponent,
    CallrulesComponent,
    ProjectComponent,
    DeviceComponent,
    TelcoComponent,
    DestinationComponent,
    CurrenconversionComponent,
    CountryconfigurationComponent,
    CommonareaphoneComponent,
    DailinconferenceComponent,
    LeaversComponent,
    RetaggingOfCallsComponent,
    SuggestionAndFeedbackComponent,
    LoginComponent,
    HomeComponent,
    DashboardComponent,
    DashboardFeedbackComponent,
    DashboardProjectLeadComponent,
    DashboardVoiceAdminCAPComponent,
    DashboardVoiceAdminCountryComponent,
    DashboardVoiceAdminGatewayComponent,
    DashboardVoiceAdminGlobalCountryComponent,
    DashboardVoiceAdminTrunkCallComponent,
    OnlineSupportComponent,
    SuggestionsComponent,
    MyprofileComponent,
    ActivateAuthcodeComponent,
    DeactivateAuthcodeComponent,
    TermsAndConditionsComponent,
    ShortCodeComponent,
    MainDashboardComponent,
    SourceComponent,
    GroupaccessComponent,
    ModalComponent,
    AlertsComponent,
    ToastComponent,
    ManageaccessComponent,
    SchedulereportsComponent,
    RecoveryreportsComponent,
    SummaryreportsComponent,
    AddAuthLevelComponent,
  ],
  imports: [
    FormsModule,
    BrowserModule,
    AgGridModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgMultiSelectDropDownModule.forRoot(),
    RebarAuthModule.forRoot(),
    BrowserAnimationsModule,
    MatDatepickerModule,
    MatIconModule,
    MatMomentDateModule,
    MatNativeDateModule,
   
    BsDatepickerModule.forRoot(),
    NgIdleKeepaliveModule.forRoot(),
    MomentModule,
    MsalModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  providers: [
    EncrDecrService,
    PagerService,
    DatePipe,
    {
      provide: APP_INITIALIZER,
      useFactory: (config: AppConfigService) => () => config.load(),
      deps: [AppConfigService],
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true },
    MsalService,
  ],

  bootstrap: [AppComponent, MsalRedirectComponent],
})
export class AppModule {}
